import IInvite from "../models/invite/IInvite";
import IInviteRecord from "../models/invite/IInviteRecord";
import networkService from "./networkService";

class InviteService {
    
    async getInvites(): Promise<IInviteRecord[]> {
        const result = await networkService.get<IInviteRecord[]>("invite");
        
        if (result.isSuccessful) {
            return result.data as IInviteRecord[];
        }

        throw result.data;
    }

    async inviteUsers(invite: IInvite) : Promise<boolean> {
        const result = await networkService.put<IInvite, void>("invite", invite);
        
        if (result.isSuccessful) {
            return result.isSuccessful;
        }

        throw result.data;
    }
}

const inviteService = new InviteService();
export default inviteService;